import * as React from 'react';
import { IndexRedirect, Route } from 'react-router';

import { GroupClassmatesPageDynamic } from '@coursera-web/group-roster';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import courseReferencesRoutes from 'bundles/course-home/page-course-references/courseReferencesRoutes';
/* eslint-disable @coursera/restrict-imports/no-cross-scope-imports */
import discussionsRoutes from 'bundles/course-home/page-discussion-forums/routes';
import CourseHomeRefreshRedirect from 'bundles/course-v2/utils/CourseHomeRefreshRedirect';
import { SubmissionTableRoute } from 'bundles/peer-admin/constants/constants';

/* eslint-enable @coursera/restrict-imports/no-cross-scope-imports */

const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

const Home = loadOnRoute(() => import('bundles/course-v2/components/Home'));

const CourseInfo = loadOnRoute(() => import('bundles/course-home/page-course-info/components/CourseInfoPage2016'));

const CoachPage = loadOnRoute(() => import('bundles/course-home/page-course-coach/components/CoachPage'));

const NotesReviewPage = loadOnRoute(() => import('bundles/video-highlighting/review-page/NotesReviewPage'));

const AssignmentsPage = loadOnRoute(() => import('bundles/course-home/page-course-grades/components/AssignmentsPage'));

const PeriodPage = loadOnRoute(() => import('bundles/course-home/page-course-week/components/PeriodPage'));

const ItemRedirector = loadOnRoute(() => import('bundles/item/components/ItemRedirector'));

const CourseInboxPage = loadOnRoute(() => import('bundles/course-home/page-course-inbox/components/CourseInboxPage'));

const OfficeHoursPage = loadOnRoute(() => import('bundles/group-events/components/OfficeHoursPage'));

const GroupClassmatesPage = loadOnRoute(GroupClassmatesPageDynamic);

const ProfileApp = loadOnRoute(() => import('bundles/profile/components/ProfileApp'));

const TeamworkPageV2 = loadOnRoute(() => import('bundles/course-teamwork/components/TeamworkPageV2'));

const PeerReviewAdminLearnContainer = loadOnRoute(
  () => import('bundles/peer-admin/components/PeerReviewAdminLearnContainer')
);

const CourseDataProvider = loadOnRoute(() => import('bundles/course-v2/components/CourseDataProvider'));

export default (
  <Route getComponent={Home}>
    <Route path="home">
      <Route path="notes" name="notes" getComponent={NotesReviewPage} />

      {/* All of these routes are CSR. CourseDataProvider makes sure they all get relevant course data. */}
      <Route getComponent={CourseDataProvider}>
        <Route path="welcome" name="welcome" component={CourseHomeRefreshRedirect} />
        <Route path="info" name="CDP" getComponent={CourseInfo} />
        {/* TODO LRNENG-3369: Upon graduating the week to module project, decide if we would like to replace this
            week route with a redirect (preserving people's bookmarks), or remove it altogether and allow
            a slower welcome redirect to occur
         */}
        <CourseraRoute
          path="week/:week"
          name="week"
          getComponent={PeriodPage}
          handle={{
            tracking: {
              data: () => {
                return {
                  page: {
                    segment: 'consumer',
                    type: 'course_module',
                  },
                };
              },
            },
          }}
        />
        {/* Keeping the param name as week for now so we dont need to dig through the code and create
            branches for the epic when react-router uses that param by name
        */}
        <CourseraRoute
          path="module/:week"
          name="module"
          getComponent={PeriodPage}
          handle={{
            tracking: {
              data: () => {
                return {
                  page: {
                    segment: 'consumer',
                    type: 'course_module',
                  },
                };
              },
            },
          }}
        />
        <Route path="assignments" name="assignments" getComponent={AssignmentsPage} />
      </Route>

      <IndexRedirect to="welcome" />
      <Route path="*" getComponent={NotFound} />
    </Route>
    <Route getComponent={CourseDataProvider}>
      {discussionsRoutes}
      {courseReferencesRoutes}

      <Route path="office-hours" name="office-hours" getComponent={OfficeHoursPage} />
      <Route path="classmates" name="classmates" getComponent={GroupClassmatesPage} />
      <Route path="coach" name="coach" getComponent={CoachPage} />
      <Route path="teamwork" name="teamwork" getComponent={TeamworkPageV2} />
      <Route
        path="peer-admin/:itemId(/:slug)"
        name={SubmissionTableRoute}
        getComponent={PeerReviewAdminLearnContainer}
      />

      <Route path="course-inbox" name="course-inbox" getComponent={CourseInboxPage} />
      <Route path="profiles/:id" getComponent={ProfileApp} />

      <Route
        getComponent={ItemRedirector}
        path="item/:id(/:a(/:b(/:c(/:d(/:e(/:f(/:g(/:h(/:i(/:j(/:k(/:l))))))))))))"
      />
    </Route>
  </Route>
);
